import { authStorage } from 'storages';
import { AuthenticationError, getErrorMessage } from 'shared/errors';
import { getAuthQueryParams } from '../helpers';

export const checkQueryAuthParams = async () => {
  try {
    const authQueryParams = getAuthQueryParams();

    if (!authQueryParams.accessToken || !authQueryParams.refreshToken) return;

    await authStorage.setJwtAuthParams({
      access: authQueryParams.accessToken,
      refresh: authQueryParams.refreshToken,
    });
  } catch (error) {
    const pref = 'CheckQueryAuthParams: ';
    const errorMessage = getErrorMessage(`${pref}${error}`);

    if (errorMessage) throw new Error(errorMessage);

    throw new AuthenticationError('Catch error while check query auth params!');
  }
};
